import screenfull from 'screenfull';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import BarcodeScanner from '@dsisolutions/react-barcode-scanner';
import { modal } from '../../modal/ModalEmitter';

const FormHelperBarcodeScanner = ({ setValue, blurValue, fullscreen = false, size = 'xs' }) => {
  const onSubmit = value => {
    if (screenfull.isEnabled) {
      screenfull.exit();
    }

    setValue(value, blurValue);
    modal.close();
  };

  const onCancel = () => {
    if (screenfull.isEnabled) {
      screenfull.exit();
    }
    modal.close();
  };

  const onClick = () => {
    if (screenfull.isEnabled && fullscreen) {
      screenfull.request();
    }
    modal.open('info', {
      title: 'Scan Barcode',
      hidePrint: true,
      hideFooter: true,
      message: (
        <BarcodeScanner
          decoder={['code_128', 'upc', 'code_39', 'code_39_vin', 'upc_e']}
          consecutiveMatchCount={1}
          scansPerSecond={25}
          useScanWindow
          onSubmit={onSubmit}
          onCancel={onCancel}
        />
      ),
    });
  };

  return (
    <Button key="bcs" size={size} title="Scan Barcode" onClick={onClick} tabIndex="-1" variant="secondary">
      <i className="fad fa-barcode-read" />
    </Button>
  );
};

FormHelperBarcodeScanner.propTypes = {
  setValue: PropTypes.func,
  blurValue: PropTypes.func,
};

export default FormHelperBarcodeScanner;
